import { render, staticRenderFns } from "./questionChoiceOne.vue?vue&type=template&id=eeb04996&scoped=true"
import script from "./questionChoiceOne.vue?vue&type=script&lang=js"
export * from "./questionChoiceOne.vue?vue&type=script&lang=js"
import style0 from "./questionChoiceOne.vue?vue&type=style&index=0&id=eeb04996&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb04996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb04996')) {
      api.createRecord('eeb04996', component.options)
    } else {
      api.reload('eeb04996', component.options)
    }
    module.hot.accept("./questionChoiceOne.vue?vue&type=template&id=eeb04996&scoped=true", function () {
      api.rerender('eeb04996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionChoiceOne.vue"
export default component.exports